// import 'zone.js'
// import '../lang/index.js'
import { createApp } from 'vue'
import router from './router'
import { store, key } from '@y/shared'
import App from './App.vue'
import elementPlus from './plugins/element-plus'
import zUi from 'y-ui'
import 'y-ui/dist/es/packages/style.css'
import shared from './micro/shared'
import { CLIENT_ID } from '@/utils/constants'

// 加载全局样式
import './styles/index.less'
import { initUsedPlugins } from '@y/composables'
import { initBaseDependence } from '@y/axios'
import { DbService } from '@y/utils'

const app = createApp(App)

const composablesInitPlugins: Record<string, any> = {
  useRoute: router.currentRoute,
  useRouter: router,
  shared,
}
const baseDependence: any = {
  router,
  APP_NAME: 'admin',
  isContainer: true,
}

const dbService = new DbService({
  name: `${CLIENT_ID}-db`,
  storeName: 'table-column-config',
  version: 1.0,
  description: 'store table column config',
}).getInstance()
app.provide('dbService', dbService)

app.use(elementPlus)
app.use(zUi)

app.use(router)
app.use(store, key)

initUsedPlugins(composablesInitPlugins)
initBaseDependence(baseDependence)

// 自动注册全局组件
// const modules = require.context('./components', true, /\.ts$/)
// modules.keys().forEach((filePath) => {
//   app.use(modules(filePath).default)
// })

app.mount('#app')
